<template>
  <ContainerProduction
    v-if="rendersInline"
    v-bind="$attrs"
    :option-values="optionValues"
    :active-state="activeState"
    :identifier="identifier"
    :theme-mode="themeMode"
    :edit-mode="editMode"
  >
    <slot />
  </ContainerProduction>
</template>

<script>
import ContainerProduction from "%/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { PlanSheetScopeMixin } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-scope-mixin";
import { rendersSheetInline } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

// Web members only have card checkout, so Subscribe goes straight there and the sheet never renders.
export default {
  name: "SubscriptionPlanSheet",
  components: { ContainerProduction },
  production: true,
  mixins: [DynamicElementMixin, PlanSheetScopeMixin],
  inheritAttrs: false,
  computed: {
    rendersInline() {
      return rendersSheetInline(this.editMode);
    },
  },
};
</script>
